import { c as _c } from "react/compiler-runtime";
import { queryStateParser, queryStateSerializer, SerializationType } from '@/utils/useQueryParamState/utils';
import { createParser, useQueryState } from 'nuqs';
import type { Options } from 'nuqs';
import { useMemo } from 'react';
export type UseQueryParamStateOptions = {
  scroll?: boolean;
  pushOrReplace?: 'push' | 'replace';
  clearOnDefault?: boolean;
  type: SerializationType;
};

// const defaultValues: UseQueryParamStateOptions = {
//   scroll: false,
//   pushOrReplace: 'replace',
//   type: 'objectORnumberORboolean',
// };

// /**
//  * @deprecated use useQueryParamStateV2 instead
//  */
// export const useQueryParamState_old = <T,>(
//   key: string,
//   defaultValue: T,
//   opts: UseQueryParamStateOptions = defaultValues,
// ) => {
//   const { pushOrReplace = 'replace', scroll = false, type } = opts;
//
//   const searchParams = useSearchParams();
//   const router = useRouter();
//   const pathname = usePathname();
//
//   const defaultRef = useRef(defaultValue);
//   const paramValue = useMemo(() => searchParams.get(key), [searchParams, key]);
//   const [state, setState] = useState<T>(() => parseState(paramValue, defaultValue, type));
//   const hashedRef = useRef<string | null>(null);
//
//   useEffect(() => {
//     const val = queryStateSerializer(state, type);
//     if (hashedRef.current === val) return;
//     hashedRef.current = val;
//     updateURL(pathname, searchParams, key, val, pushOrReplace, scroll, router);
//   }, [state, key, pathname, scroll, pushOrReplace, type, searchParams, router]);
//
//   useEffect(() => {
//     if (paramValue === null) return setState(defaultRef.current);
//     if (hashedRef.current === paramValue) return;
//     setState(parseState(paramValue, defaultRef.current, type));
//   }, [paramValue, type]);
//
//   return [state, setState] as const;
// };

// =================================
// UTILS
// =================================

type PrevFunction<T> = (prev: T) => T;
export type SetStateParam<T> = T | PrevFunction<T>;
/**
 * NOTES:
 * use this from now on! yeah!
 *
 * @param key
 * @param defaultValue
 * @param opts
 */
export function useQueryParamStateV2(key, defaultValue, opts) {
  const $ = _c(8);
  const {
    pushOrReplace: t0,
    scroll: t1,
    clearOnDefault,
    type
  } = opts;
  const pushOrReplace = t0 === undefined ? "replace" : t0;
  const scroll = t1 === undefined ? false : t1;
  let t2;
  if ($[0] !== type) {
    t2 = createParser({
      parse(queryValue) {
        return queryStateParser(queryValue, type) as TValue;
      },
      serialize(value) {
        if (value === undefined || value === null) {
          return null;
        }
        return queryStateSerializer(value, type);
      }
    });
    $[0] = type;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  const genericParser = t2;
  let t3;
  if ($[2] !== clearOnDefault || $[3] !== defaultValue || $[4] !== genericParser || $[5] !== pushOrReplace || $[6] !== scroll) {
    t3 = genericParser.withDefault(defaultValue).withOptions({
      history: pushOrReplace,
      scroll,
      clearOnDefault
    });
    $[2] = clearOnDefault;
    $[3] = defaultValue;
    $[4] = genericParser;
    $[5] = pushOrReplace;
    $[6] = scroll;
    $[7] = t3;
  } else {
    t3 = $[7];
  }
  return useQueryState(key, t3);
}